import { EventEmitter, Injectable } from '@angular/core';
import { BroadcastHubMessage } from '../interfaces/broadcast-hub-message';

@Injectable()
export class BroadcastHubEventService {
  public DriverInfoEvent: EventEmitter<BroadcastHubMessage<any>> = new EventEmitter<
    BroadcastHubMessage<any>
  >();

  public TelephonyEvent: EventEmitter<BroadcastHubMessage<any>> = new EventEmitter<
    BroadcastHubMessage<any>
  >();

  public OrderImportEvent: EventEmitter<BroadcastHubMessage<any>> = new EventEmitter<
    BroadcastHubMessage<any>
  >();

  public DeployInspectionsEvent: EventEmitter<BroadcastHubMessage<any>> = new EventEmitter<
    BroadcastHubMessage<any>
  >();
}
